import { render, staticRenderFns } from "./invoice-list.vue?vue&type=template&id=4b467c1c&scoped=true"
import script from "./invoice-list.vue?vue&type=script&lang=ts"
export * from "./invoice-list.vue?vue&type=script&lang=ts"
import style0 from "./invoice-list.vue?vue&type=style&index=0&id=4b467c1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b467c1c",
  null
  
)

export default component.exports